import "@/index.css";
import { waitUntilReady } from '@api-client/auth/auth';
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import { initSentry } from '@auth-frontend-vue/instrument';
// import { useI18n } from 'vue-i18n'
// const { locale } = useI18n()
// function changeLang(lang: 'en' | 'tr' | 'es') {
//     locale.value = lang
// }

const params = new URLSearchParams(window.location.search);
window.queryParams = {
    auth: (params.get('auth') as "login" | "signup" | "otp") || "login",
    type: (params.get('type') as "ask" | "settings") || "settings",
    lang: (params.get('lang') as "en" | "tr" | "es") || "en",
    next: params.get('next') || `https://www.${import.meta.env.PUBLIC_DOMAIN_NAME}/`,
    state: params.get('state'), // TODO: do we need this?
    remember_email: params.get('remember_email'),
    pkce_code_challenge: params.get('pkce_code_challenge'),
    pkce_state: params.get('pkce_state'),
};

const i18n = createI18n({
    legacy: false,
    locale: window.queryParams.lang,
    fallbackLocale: 'en',
    messages: {
        en: {
            logout: 'Logout',
            logoutEverywhere: 'Logout everywhere',
            login: 'Login',
            signup: 'Sign Up',
            otp: 'One Code',
            signInOrCreate: 'Sign in',
            enterEmailToContinue: 'Enter your email to continue',
            enterEmailOrPhoneToContinue: 'Enter your email or phone to continue',
            enterPhoneToContinue: 'Enter your phone number to continue',
            continueWithPhone: 'Continue with phone',
            continueWithEmail: 'Use email instead',
            phoneNumber: 'Phone number',
            continue: 'Continue',
            change: 'Change',
            welcomeBack: 'Welcome back',
            enterPasswordToContinue: 'Enter your password to continue',
            forgotPassword: 'Forgot password?',
            createAccount: 'Create account',
            fillDetailsToContinue: 'Fill in your details to continue',
            signUpWithCode: 'Sign up passwordless',
            enterCode: 'Enter code',
            codeSentToEmail: 'We sent a one-time code to your email',
            codeSentToPhone: 'We sent a one-time code to your phone',
            settings: 'Settings',
            goBackTo: 'Go {hostname}',
            loginWithGoogle: 'Continue with Google',
            passwordsMustMatch: "Passwords must match",
            freshSessionRequired: "Fresh login required to update security settings",
            pleaseLogoutAndLoginAgain: "You need to logout and login",
            passwordUpdated: "Password updated",
            nameUpdated: "Name updated",
            yourEmail: "Your email",
            yourName: "Your name",
            newPassword: "New password",
            confirmPassword: "Confirm password",
            update: "Update",
            cancel: "Cancel",
            security: "Security",
            updatePassword: "Update Password",
            updateName: "Update Name",
            oneTimePassword: "One-time password",
            sendClaimEmailCode: "Send code",
            claimEmailCodeSent: "Code sent",
            claimEmailEnterCode: "Enter the 4-digit code we sent to",
            useDifferentEmail: "Use a different email",
            verify: "Verify",
            addEmail: "Add Email",
            changeEmail: "Change Email",
            newEmail: "New email",
            changeEmailWarning: "We will send a code to your new email. After the change you will be logged out everywhere and must login with the new email.",
            emailChangedLoginAgain: "Email changed. Please login with your new email.",
            changePhone: "Change Phone",
            newPhoneNumber: "New phone number",
            changePhoneWarning: "We will send a code to your new phone number. Your old number will be removed from your account and cannot be verified again for 1 year.",
            useDifferentPhone: "Use a different number",
            phoneChanged: "Phone number changed",
            verifyEmailBeforePhoneChange: "Please verify your email before changing your phone number",
        },
        // ignore other languages for now
        // tr: {
        //     logout: 'Çıkış yap',
        // },
        // es: {
        //     logout: 'Cerrar sesión',
        // }
    }
});


waitUntilReady.then(() => {
    const app = createApp(App);
    initSentry(app);
    app.use(i18n)
    app.mount('#app');
})
